import {
  GET_RECRUITMENT,
  RECRUITMENT_LOADING,
  SET_RECRUITMENT_ITEMS_PER_PAGE,
  CHANGE_CURRENT_RECRUITMENT_PAGE,
  SEARCH_RECRUITMENT,
  FILTER_RECRUITMENT_FUNCTIONS,
  FILTER_RECRUITMENT_ROLES,
  FILTER_RECRUITMENT_STATUS,
  FILTER_RECRUITMENT_RECRUITER,
  FILTER_RECRUITMENT_DATE,
  FILTER_PROFILE_TABLE_DATE,
  FILTER_FINAL_PRICING_DATE,
  FILTER_ASSIGNED_TO_RECRUITER_DATE,
  SET_RECRUITMENT_PRICING_HISTORY,
  FILTER_RECRUITMENT_NUMBER_OF_DAYS,
} from "../actions/recruitmentAction";

const initialState = {
  RecruitmentList: [],
  RecruitmentPricingHistory: [],
  RecruitmentSearchText: "",
  RecruitmentAppliedFunctionFilter: [],
  RecruitmentAppliedRolesFilter: [],
  RecruitmentAppliedStatusFilter: [],
  RecruitmentAppliedRecruiterFilter: [],
  RecruitmentAppliedDateFilter: [],
  RecruitmentAppliedProfileDateFilter: [],
  RecruitmentAppliedFinalPricingFilter: [],
  RecruitmentAppliedAssignedToRecruiterFilter: [],
  RecruitmentAppliedNoOfDaysFilter: [],
  RecruitmentTotalResults: null,
  RecruitmentCurrentPage: 1,
  RecruitmentResultsPerPage: 10,
  RecruitmentTotalPages: null,
  RecruitmentPageIds: [],
  RecruitmentFunctionFilter: [],
  RecruitmentRolesFilter: [],
  RecruitmentRecruiterFilter: [],
  RecruitmentNoOfDaysFilter: [],
  fetchingData: true,
};

const recruitmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RECRUITMENT: {
      return {
        ...state,
        RecruitmentList: action.payload.result.results,
        RecruitmentTotalResults: action.payload.result.total_results,
        RecruitmentTotalPages: action.payload.result.total_pages,
        RecruitmentPageIds: action.payload.result.page_ids,
        RecruitmentFunctionFilter: action.payload.filter_data.functions,
        RecruitmentRolesFilter: action.payload.filter_data.roles,
        RecruitmentRecruiterFilter: action.payload.filter_data.recruiters,
        RecruitmentNoOfDaysFilter: action.payload.filter_data.no_of_days,
        fetchingData: false,
      };
    }
    case SET_RECRUITMENT_PRICING_HISTORY: {
      return {
        ...state,
        RecruitmentPricingHistory: action.payload,
      };
    }
    case CHANGE_CURRENT_RECRUITMENT_PAGE: {
      return {
        ...state,
        RecruitmentCurrentPage: action.payload,
      };
    }
    case SET_RECRUITMENT_ITEMS_PER_PAGE: {
      return {
        ...state,
        RecruitmentResultsPerPage: action.payload,
      };
    }
    case SEARCH_RECRUITMENT: {
      return {
        ...state,
        RecruitmentSearchText: action.payload,
      };
    }
    case FILTER_RECRUITMENT_FUNCTIONS: {
      return {
        ...state,
        RecruitmentAppliedFunctionFilter: action.payload,
      };
    }
    case FILTER_RECRUITMENT_ROLES: {
      return {
        ...state,
        RecruitmentAppliedRolesFilter: action.payload,
      };
    }
    case FILTER_RECRUITMENT_STATUS: {
      return {
        ...state,
        RecruitmentAppliedStatusFilter: action.payload,
      };
    }
    case FILTER_RECRUITMENT_RECRUITER: {
      return {
        ...state,
        RecruitmentAppliedRecruiterFilter: action.payload,
      };
    }
    case FILTER_RECRUITMENT_NUMBER_OF_DAYS: {
      return {
        ...state,
        RecruitmentAppliedNoOfDaysFilter: action.payload,
      };
    }
    case FILTER_RECRUITMENT_DATE: {
      return {
        ...state,
        RecruitmentAppliedDateFilter: action.payload,
      };
    }
    case FILTER_PROFILE_TABLE_DATE: {
      return {
        ...state,
        RecruitmentAppliedProfileDateFilter: action.payload,
      };
    }
    case FILTER_FINAL_PRICING_DATE: {
      return {
        ...state,
        RecruitmentAppliedFinalPricingFilter: action.payload,
      };
    }
    case FILTER_ASSIGNED_TO_RECRUITER_DATE: {
      return {
        ...state,
        RecruitmentAppliedAssignedToRecruiterFilter: action.payload,
      };
    }
    case RECRUITMENT_LOADING: {
      return {
        ...state,
        fetchingData: true,
      };
    }
    default:
      return state;
  }
};

export default recruitmentReducer;
